import type { InjectionKey } from "vue";

export const sidePanelKey: InjectionKey<{ close: () => void }> = Symbol("sidePanel");
